import {BUSCAR_PLATAFORMAS} from '../../actions/types'

const initialState = []

export default function reducerPlataformas(state = initialState, action) {
    switch (action.type) {
        case BUSCAR_PLATAFORMAS: {
            return action.payload.data
        }

        default: {
            return state
        }
    }
}
